import { supabase } from "@/lib/supabase";

/** Shape returned by the get_public_participant_profile RPC. */
export interface PublicParticipantProfile {
  participant_id: string;
  event_id: string;
  event_title: string;
  name: string;
  role: string | null;
  company: string | null;
  headline: string | null;
  looking_for: string | null;
  can_help_with: string | null;
  video_storage_path: string | null;
}

/**
 * Public lookup for /p/:participantId. Returns null when the participant
 * cannot be resolved (deleted, wrong id, etc.) so the page can render a
 * friendly empty state instead of throwing.
 */
export async function fetchPublicProfile(
  participantId: string,
): Promise<PublicParticipantProfile | null> {
  const { data, error } = await supabase.rpc("get_public_participant_profile", {
    p_participant_id: participantId,
  });
  if (error) throw new Error(error.message);
  const rows = (data ?? []) as PublicParticipantProfile[];
  return rows[0] ?? null;
}
